/**
 * Helpers de data da edição inline.
 *
 * Módulo separado do componente de propósito: são funções puras, e mantê-las
 * dentro de `InlineEditDate.tsx` obrigava o teste a importar o componente —
 * que arrasta react-day-picker e Radix Popover para dentro de um ambiente de
 * teste `node`, sem DOM. O teste então reimplementava as funções para se
 * defender disso, o que o tornava inútil: mudar o código real deixava o teste
 * verde. Aqui as duas coisas voltam a apontar para a mesma implementação.
 *
 * Estas funções são o que impede o loop infinito de render: um `Date` novo a
 * cada render nunca é igual por `Object.is`, então sem uma comparação
 * semântica o `setDraft` de sincronização agendava render após render.
 */

/** Compara só o dia — o campo é uma previsão, o horário é irrelevante. */
export function sameDay(a: Date | null, b: Date | null): boolean {
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  return a.toDateString() === b.toDateString();
}

/**
 * Chave primitiva e estável para memoizar a data recebida por prop.
 *
 * Precisa ser primitiva: é o que permite ao `useMemo` devolver o MESMO objeto
 * `Date` entre renders. Devolver o próprio `Date` como dependência recriaria a
 * identidade a cada render e reabriria o loop.
 */
export function dateKey(value: Date | string | null | undefined): number | null {
  if (!value) return null;
  const t = value instanceof Date ? value.getTime() : new Date(value).getTime();
  return Number.isNaN(t) ? null : t;
}
